module.exports = __webpack_public_path__ + "img/20200514_143429.4c9aaa14.jpg";